import React from "react";
import {Button, Icon, Image, Popup} from 'semantic-ui-react'
import ReservedSeat from "../../../../../assets/img/recerved-seat.png";

function Picture2(props) {
    return (
        // <img
        //     ref={drag}
        //     src={url}
        //     width="150px"
        //     style={{ border: isDragging ? "5px solid pink" : "0px" }}
        // />

      <Popup
        content={props.seat===undefined?"No details":props.seat}
        key={props.url===undefined?"No details":props.url}
        header={props.url===undefined?"No details":props.url}
        trigger={
          <div>
            <img src={ReservedSeat} alt="" width={25}/>
            <div className={"eye"} onClick={ () => props.openReservationModal(props.value, props.seat) }>
              {/*{*/}
              {/*  url===undefined?"No details":url*/}
              {/*}*/}
              <Icon circular name='eye' />
            </div>
          </div>
        }
      />

        // <div>
        //     <img src={"https://img.icons8.com/color/48/000000/reservation.png"} alt="" width={45}/>
        //     <div>
        //       {
        //         url===undefined?"No details":url
        //       }
        //     </div>
        // </div>


    );
}

export default Picture2;
